import React from 'react';
import PropTypes from 'prop-types';
import Link from '@nubank/nuds-web/components/Link/Link';

const LinkGat = ({ label }) => (
  <Link
    href="/gat"
    variant="action"
    typographyProps={{ variant: 'paragraph1' }}
    target="_blank"
  >
    {label}
  </Link>
);

LinkGat.propTypes = {
  label: PropTypes.string,
};

LinkGat.defaultProps = {
  label: 'Conoce GAT Real y Nominal de Cuenta',
};

export default LinkGat;
